<template>
  <div>
    <div class="face_header">
      <div class="face_header_con">
        <p class="face_header_lf">{{ this.testInfo.examName }}</p>
        <a class="face_header_rg" @click="logoutHandle">
          <span class="headsp"><img src="@/assets/images/exit.png"/></span>
          退出
        </a>
        <router-link to="/profile" class="face_header_rg">
          <span class="headsp"><img src="../assets/images/icon-user.png"/></span
          >{{ this.userInfo.userName }}
        </router-link>
      </div>
    </div>
    <!-- <div class="query_tit">
      <ul>
        <a href="javascript:void(0);" @click="readNotice()">1、阅读考试须知</a
        >&nbsp;&nbsp;&nbsp;&nbsp;
        <a href="javascript:void(0);" @click="confirmInfo()">2、确认个人信息</a>
      </ul>
    </div> -->
    <div class="query_con">
      <h2 class="exam_con_t xz_t">重要提示</h2>
      <p class="ksxz_ft">
        <span class="ksxz_con">1、点击“开始考试”正式进入考试并倒计时<br />2、如还未准备好考试，可点击“取消考试”</span>
      </p>

      <div class="exam_stru_con">
        <div class="dt_btn">
          <a href="javascript:void(0)" @click="exit">取消考试</a>
          <a href="javascript:void(0)" @click="nextStep">开始考试</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getExamById, logout, myInfo, sendStopPushStreamMsg, createQueryfaceRecord } from "@/api/login";
export default {
  name: "ExamConfirm",
  data() {
    return {
      examBean: {
        token: ""
      },
      tokenBean: {
        token: "",
        examUserId: "",
        orderNo: ""
      },
      testInfo: {},
      userInfo: {},
      examUserId: "",
      uploadUrl: process.env.VUE_APP_RETURN_URL,
      readExamNotice: true,
      allowResume: ""
    };
  },
  created() {
    this.examBean.token = this.getToken();
    this.examUserId = this.$route.query.examUserId;
    this.tokenBean.token = this.getToken();
    this.tokenBean.examUserId = this.examUserId;

    this.initData();

  },
  computed: {
    token() {
      return this.getToken();
    }
  },
  methods: {
    initData() {
      console.log(this.tokenBean);
      getExamById(this.tokenBean).then(res => {
        console.log(res);
        if (res.code === 200) {
          this.testInfo = res.data;
          console.log(this.testInfo);
          this.allowResume = this.testInfo.allowResume;
          this.checkAndGo();
        } else if (res.code === 8003) {
          this.$router.push("/login");
          return;
        }
      });
      myInfo(this.tokenBean).then(res => {
        if (res.code === 200) {
          console.log(res.data);
          this.userInfo = res.data.user;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    
    gelDelURL() {
        return window.location.href
          .substring(0,window.location.href.indexOf("?"));
    },

    checkAndGo() {
      this.code = window.location.href;
      this.code = this.code.substring(this.code.indexOf("?") + 1);
      this.code = this.code.substring(0, this.code.indexOf("&"));

      let orderNoPart = window.location.href;
      orderNoPart = orderNoPart.substring(orderNoPart.indexOf("orderNo=") + 8);
      this.tokenBean.orderNo = orderNoPart.substring(0,orderNoPart.indexOf("&"));

      // let queryDate = this.$route.query;
      // console.log(queryDate);
      // if(queryDate.code) {
      //   delete this.route.$query.code;
      // }
      window.history.replaceState(null, null, this.gelDelURL());

      // 人脸识别返回
      if (this.code !== "") {
        // 创建人脸验证结果查询任务
        createQueryfaceRecord(this.tokenBean);
        this.code = this.code.substring(this.code.indexOf("=") + 1);
        if (this.code !== "0") {
          // 特例考生
          if (this.userInfo.specialFlag === 1) {
              this.$router.push({
                path: "/examConfirm",
                query: { examUserId: this.examUserId }
              });
              return;
          }
          else {
            this.$message.error("人脸核身失败，请重新验证。");
            this.$router.push({
              path: "/examNeedToKnow",
              query: { examUserId: this.tokenBean.examUserId }
            });
            return;
          }
        }
        else {
          // 需要过程抓拍，且开启检测摄像头
          if (this.testInfo.detectInprocess ===2 &&  this.testInfo.useVideo === 2) {
            this.$router.push({
              path: "/checkVideo",
              query: { examUserId: this.examUserId }
            });
            return;
          }

          // 需要后置摄像头实时监控
          if (this.testInfo.backCamera === 2) {
            this.$router.push({
              path: "/backCameraQrcode",
              query: { examUserId: this.examUserId }
            });
            return;
          }
        }
      }
    },

    nextStep() {
      this.$router.push({
        path: "/examCatalog",
        query: { examUserId: this.examUserId }
      });
    },
    readNotice() {
      this.$router.push({
        path: "/examNeedToKnow",
        query: { examUserId: this.examBean.examUserId }
      });
    },
    confirmInfo() {
      this.$router.push({
        path: "/confirmProfile",
        query: { examUserId: this.examBean.examUserId }
      });
    },
    logoutHandle() {
      if (confirm("退出确认")) {
        this.tokenBean.token = this.token;
        logout(this.tokenBean).then(res => {
          if (res.code === 200) {
            this.removeUserInfo();
            this.$router.push("/login");
          }
        });
      }
    },
    exit() {
      if(this.testInfo.backCamera === 2) {
        sendStopPushStreamMsg(this.tokenBean);
      }
      
      this.$router.push("/curExam");
    }
  }
};
</script>

<style scoped></style>
